<template>
<div class="key-component-chart-group">
  <trend-related-chart
    :data-config="dataConfig"
    :unit-prop="unitProp"
    :download-name="downloadName"
    click-able
  />

  <x-y-chart
    v-if="backgroundData"
    :data-config="backgroundData"
    :unit-prop="unitProp"
    :chart-type="chartType"
    :stack-type="stackType"
    :download-name="backgroundDownloadName"
    selected-change-with-data-changed
    :show-selected-ctrl-btn="false"
    :y-axis-scale="false"
    :min-max="minMax"
    chart-min-height="245px"
    chart-height="auto"
  >
    <template #toolbar>
      <el-select
        v-model="backgroundFactorId"
        size="small"
        style="width:130px;"
        @change="onBackgroundFactorIdChanged"
      >
        <el-option
          v-for="backgroundFactor in filterBackgroundFactorConfigs"
          :key="backgroundFactor.id"
          :value="backgroundFactor.id"
          :label="factorMap[backgroundFactor.id].name"
        />
      </el-select>

      <el-input
        v-model="backgroundValue"
        type="number"
        size="small"
        style="width:250px;"
        @change="onBackgroundValChanged"
      >
        <template slot="prepend">背景浓度</template>
        <template slot="append">PPB</template>
      </el-input>
    </template>
  </x-y-chart>
</div>
</template>

<script>
import TrendRelatedChart from '../../../../../components/Data/TrendRelatedChart'
import XYChart from '../../../../../components/DataChart/XYChart'

export default {
  name: 'KeyComponentChartGroup',
  components: {XYChart, TrendRelatedChart},
  props: {
    backgroundFactorConfigMap: {
      required: true,
      type: Object
    },
    dataConfig: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    unitProp: 'stdUnit',
    chartType: 'line',
    stackType: 1,
    backgroundFactorId: null,
    backgroundValue: null,
    backgroundData: null,
    backgroundDownloadName: '',
    minMax: Object.freeze({})
  }),
  computed: {
    downloadName: () => '关键物种',
    factorMap () {
      return this.dataConfig.dimensions.reduce((map, dimension) => {
        map[dimension.id] = dimension
        return map
      }, {})
    },
    filterBackgroundFactorConfigs () {
      let {backgroundFactorConfigMap} = this
      return this.dataConfig.dimensions.filter(dimension => backgroundFactorConfigMap[dimension.id])
    }
  },
  methods: {
    onBackgroundFactorIdChanged (backgroundFactorId, isUpdateBackgroundValue) {
      let backgroundFactorConfig = this.backgroundFactorConfigMap[backgroundFactorId]

      if (isUpdateBackgroundValue !== false) {
        this.backgroundValue = backgroundFactorConfig.background
      }

      let {dataConfig} = this
      let {seriesMap} = dataConfig
      let backgroundFactor = this.factorMap[backgroundFactorId]
      let backgroundFactorName = backgroundFactor.name
      let unit = backgroundFactor[this.unitProp]
      let minBackgroundValue = Number((this.backgroundValue * 0.5).toFixed(3))
      let maxBackgroundValue = Number((this.backgroundValue * 1.5).toFixed(3))
      let values = Object.values(seriesMap[backgroundFactorId]).reduce((list, data) => {
        const {value} = data

        if (Number.isFinite(value)) {
          list.push(value)
        }

        return list
      }, [])
      let min = minBackgroundValue
      let max = maxBackgroundValue

      if (values.length > 0) {
        min = Math.min(minBackgroundValue, 0, ...values)
        min = Math.floor(min * 100) / 100
        max = Math.max(maxBackgroundValue, ...values)
        max = Math.ceil(max * 100) / 100
      }

      this.minMax = Object.freeze({
        [unit]: {
          min,
          max
        }
      })

      this.backgroundData = Object.freeze({
        id: dataConfig.id,
        name: dataConfig.name,
        dataTimes: dataConfig.dataTimes,
        dimensions: [{
          ...backgroundFactor,
          seriesParam: {
            ...backgroundFactor.seriesParam,
            markLine: {
              // silent: true,
              data: [{
                name: `${backgroundFactorName}背景浓度下限`,
                yAxis: minBackgroundValue
              }, {
                name: `${backgroundFactorName}背景浓度上限`,
                yAxis: maxBackgroundValue
              }],
              lineStyle: {
                color: 'red',
                type: 'solid'
              },
              name: `${backgroundFactorName}背景浓度`
            }
          }
        }],
        seriesMap
      })

      this.backgroundDownloadName = backgroundFactorName
    },
    onBackgroundValChanged (backgroundValue) {
      this.backgroundValue = Number(backgroundValue)
      this.onBackgroundFactorIdChanged(this.backgroundFactorId, false)
    },
    onRelatedChartDblclick () {

    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        let {factorMap, backgroundFactorId} = this

        if (factorMap[backgroundFactorId]) {
          this.onBackgroundFactorIdChanged(backgroundFactorId, false)
        } else {
          let {filterBackgroundFactorConfigs} = this

          if (filterBackgroundFactorConfigs.length > 0) {
            this.onBackgroundFactorIdChanged(this.backgroundFactorId = filterBackgroundFactorConfigs[0].id)
          } else {
            this.backgroundFactorId = this.backgroundValue = this.backgroundData = null
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.key-component-chart-group {
  display: grid;
  grid-template-rows: max-content auto;
  flex:1 0 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .background-factor-chart {
    display: grid;
    grid-template-rows: max-content auto;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .background-factor-chart-header {
      display: grid;
      grid-template-columns: auto max-content max-content;
      grid-column-gap: 12px;
      padding: 0 12px;

      &:before {
        content: "";
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/01Key-Species/KeyComponentChartGroup.vue